import { AB_TEST_CONFIGS } from './config/settings'
import type { PatternConfig, AbTestConfig, AbPattern } from './config/types'

// config を引く条件。同じ式が3つの関数に重複していたのをここに寄せた。
const isConfigMatch = (config: AbTestConfig, currentPath: string): boolean =>
    config.isActive && config.pathRegex.test(currentPath)

export const getGtmPrefix = (
    currentPath: string,
    pattern: AbPattern
): string => {
    if (pattern === 'A') return ''

    const activeConfig = AB_TEST_CONFIGS.find((config) =>
        isConfigMatch(config, currentPath)
    )

    if (!activeConfig) return ''

    const hasPattern = activeConfig.patterns.some((p) => p.pattern === pattern)
    if (hasPattern) {
        return `_${activeConfig.issueNumber}_${pattern}`
    }

    return ''
}

export const addGtmPrefix = (
    originalLabel: string,
    currentPath: string,
    pattern: AbPattern
): string => {
    const prefix = getGtmPrefix(currentPath, pattern)
    return prefix ? `${originalLabel}${prefix}` : originalLabel
}

export const getActiveAbTestConfig = (
    currentPath: string
): AbTestConfig | undefined => {
    return AB_TEST_CONFIGS.find((config) => isConfigMatch(config, currentPath))
}

export const validatePercentages = (patterns: PatternConfig[]): boolean => {
    const total = patterns.reduce((sum, pattern) => sum + pattern.percentage, 0)
    return total === 100
}

export const getPatternByPercentage = (
    abValue: number,
    patterns: PatternConfig[]
): AbPattern => {
    if (!validatePercentages(patterns)) {
        const total = patterns.reduce(
            (sum, pattern) => sum + pattern.percentage,
            0
        )
        console.error(
            `ABテスト設定エラー: パーセンテージの合計が100%ではありません (現在: ${total}%)`
        )
        console.error('設定:', patterns)
        return patterns[0].pattern
    }

    let cumulativePercentage = 0
    const scaledValue = (abValue / 10) * 100

    for (const patternConfig of patterns) {
        cumulativePercentage += patternConfig.percentage
        if (scaledValue < cumulativePercentage) {
            return patternConfig.pattern
        }
    }

    return patterns[patterns.length - 1].pattern
}


